// third party
import { Component, inject } from '@angular/core';
// local
import { MenuOpenService } from 'src/app/core/services/menu-open/menu-open.service';
import { environment } from 'src/environments/environment';
import { UserStore } from 'src/app/stores/user.store';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent {
  isIframe = false;
  isProd = environment.production;

  menuOpenService = inject(MenuOpenService);
  userStore = inject(UserStore);

  isAdmin = this.userStore.currentUserIsAdmin;

  isMenuOpen(): boolean {
    return this.menuOpenService.isMenuOpen.getValue();
  }

}
